export interface User {
  _id: string;
  username?: string;
  name: string;
  role?: UserRole;
  isTempPassword: boolean;
  companyId: string;
  deactivated: boolean;
  initiallyCreatedFrom?: "MANUAL" | "LOGISLY";
  initialLogislyRef?: {
    entityType?: string;
    externalId?: string;
    label?: string;
  };
}

export enum UserRole {
  ADMIN = "ADMIN",
  SUPERUSER = "SU",
  USER = "USER",
  DRIVER = "DRIVER",
  STAFF = "STAFF",
}

// Mapper functions
export const mapUserResponse = (response: any): User => {
  return {
    _id: response._id,
    username: response.username,
    name: response.name,
    role: response.role,
    isTempPassword: response.isTempPassword,
    companyId: response.companyId,
    deactivated: response.deactivated || false,
    initiallyCreatedFrom: response.initiallyCreatedFrom || "MANUAL",
    initialLogislyRef: response.initialLogislyRef,
  };
};

export const mapUserLoginResponse = (response: any): { token: string; user: User } => {
  return {
    token: response.token,
    user: mapUserResponse(response.user),
  };
};

/**
 * Checks if a user has admin privileges (ADMIN or SUPERUSER role)
 * @param user - The user object to check
 * @returns true if the user's role is ADMIN or SUPERUSER, false otherwise
 */
export const isUserAdmin = (user: User | null | undefined): boolean => {
  if (!user?.role) return false;
  return user.role === UserRole.ADMIN || user.role === UserRole.SUPERUSER;
};

/**
 * Checks if a user is a SUPERUSER
 * @param user - The user object to check
 * @returns true if the user's role is SUPERUSER, false otherwise
 */
export const isUserSuperUser = (user: User | null | undefined): boolean => {
  if (!user?.role) return false;
  return user.role === UserRole.SUPERUSER;
};
